import {CRUD_CREATE_FAILURE, CRUD_UPDATE_FAILURE} from "react-admin";
import {stopSubmit} from 'redux-form';
import {put, takeEvery} from "redux-saga/effects";

export default function* errorSaga() {
  yield takeEvery(CRUD_CREATE_FAILURE, crudCreateFailure);
  yield takeEvery(CRUD_UPDATE_FAILURE, crudCreateFailure);
}

export function* crudCreateFailure(action) {
  let json = action.payload;
  yield put(stopSubmit('record-form', json));
}



// WEBPACK FOOTER //
// ./src/sagas/errorSaga.js